import { render } from "./ProGuardados.vue?vue&type=template&id=244ebea4&scoped=true"
import script from "./ProGuardados.vue?vue&type=script&lang=js"
export * from "./ProGuardados.vue?vue&type=script&lang=js"

import "./ProGuardados.vue?vue&type=style&index=0&id=244ebea4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-244ebea4"

export default script